import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import {
  FailedTransaction,
  IFailedTransaction,
} from '../../../../model/failed-transaction';
import { IFailedTransactionsApiService } from './failed-transactions-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportFailedTransactionsQueryDto } from './dtos/export-failed-transactions.query.dto';
import { FindFailedTransactionsQueryDto } from './dtos/find-failed-transactions.query.dto';
import { FindFailedTransactionsResponseDto } from './dtos/find-failed-transactions.response.dto';

@Injectable({
  providedIn: 'root',
})
export class FailedTransactionsMockApiService
  implements IFailedTransactionsApiService
{
  data = {
    failed_transactions: {
      items: [] as FailedTransaction[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<IFailedTransaction>,
      subject: new BehaviorSubject<Maybe<FailedTransaction[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get failedTransactionsData() {
    return this.data['failed_transactions'] as Data<
      FailedTransaction,
      IFailedTransaction
    >;
  }

  findFailedTransactions(query: FindFailedTransactionsQueryDto): Promise<FindFailedTransactionsResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportFailedTransactions(query: ExportFailedTransactionsQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
